/* eslint-disable jira/filename-case */
import type { MEATBALL_DROPDOWN } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';

// Custom views menu items specific to JPD
export const CLONE_VIEW = 'cloneView';
export const CREATE_VIEW = 'createView';
export const DELETE_VIEW = 'deleteView';
export const EDIT_GLOBAL_VIEW = 'editGlobalView';
export const RENAME_VIEW = 'renameView';
export const REMOVE_EMOJI = 'removeEmoji';

export type ItemId =
	| typeof MEATBALL_DROPDOWN
	| typeof CLONE_VIEW
	| typeof CREATE_VIEW
	| typeof DELETE_VIEW
	| typeof EDIT_GLOBAL_VIEW
	| typeof RENAME_VIEW
	| typeof REMOVE_EMOJI
	| (string & {});
